import { createFormHook } from '@tanstack/react-form';
import { lazy } from 'react';
import { fieldContext, formContext } from './form-context';
import SubscribeButton from '@/components/forms/core/SubscribeButton';

const TextField = lazy(() => import('@/components/forms/fields/TextField'));
const TextAreaField = lazy(() => import('@/components/forms/fields/TextAreaField'));
const CheckboxField = lazy(() => import('@/components/forms/fields/CheckboxField'));
const PasswordField = lazy(() => import('@/components/forms/fields/PasswordField'));
const NumberField = lazy(() => import('@/components/forms/fields/NumberField'));
const NumberSelectField = lazy(() => import('@/components/forms/fields/NumberSelectField'));
const SelectField = lazy(() => import('@/components/forms/fields/SelectField'));
const DateField = lazy(() => import('@/components/forms/fields/DateField'));
const DurationField = lazy(() => import('@/components/forms/fields/DurationField'));
const TagsInputField = lazy(() => import('@/components/forms/fields/TagsInputField'));
const AutocompleteField = lazy(() => import('@/components/forms/fields/AutocompleteField'));
const LocationField = lazy(() => import('@/components/forms/fields/LocationField'));
const SegmentedControlField = lazy(() => import('@/components/forms/fields/SegmentedControlField'));
const RatingField = lazy(() => import('@/components/forms/fields/RatingField'));

export const { useAppForm, withForm } = createFormHook({
    fieldComponents: {
        TextField,
        TextAreaField,
        CheckboxField,
        PasswordField,
        NumberField,
        NumberSelectField,
        SelectField,
        DateField,
        DurationField,
        TagsInputField,
        AutocompleteField,
        LocationField,
        SegmentedControlField,
        RatingField,
    },
    formComponents: {
        SubscribeButton,
    },
    fieldContext,
    formContext,
});
